import { useState } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import ROUTES from '../routes';
import api from './../config/axiosInstance';

import { showToast } from '../utils/toast';
import { handleErrors } from '../utils/common';
import { fetchAndSetUserProfile } from '../config/authActions';

const Profile = () => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.auth.user);

    const [name, setName] = useState(user?.name || '');
    const [email, setEmail] = useState(user?.email || '');
    const [username, setUsername] = useState(user?.username || '');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [profileImage, setProfileImage] = useState(user?.img ? process.env.REACT_APP_IMG_URL + user.img : null);
    
    const handleEmailVerify = async () => {
        try {
            const res = await api.post(
                '/auth/verify-email',
                { email },
            );

            showToast('success', res.data.message, 'Success');
        } catch (err) {
            handleErrors(err);
        }
    }

    const handleProfileSave = async () => {
        try {
            const res = await api.put(
                '/user/profile',
                { name, email, username },
            );

            showToast('success', res.data.message, 'Success');
            dispatch(fetchAndSetUserProfile());
        } catch (err) {
            handleErrors(err);
        }
    };

    const handlePasswordChange = async () => {
        try {
            const res = await api.put(
                '/user/password-change',
                { current_password: currentPassword, new_password: newPassword },
            );

            setNewPassword('');
            setCurrentPassword('');

            if (res.status === 200) {
                showToast('success', res.data.message, 'Success');
            }
        } catch (err) {
            handleErrors(err);
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file || !file.type.startsWith('image/')) return;

        // Immediate show image
        // const reader = new FileReader();
        // reader.onloadend = () => setProfileImage(reader.result);
        // reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append('img', file);

        try {
            const res = await api.post('/user/profile/img', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });

            if (res?.status === 200) {
                showToast('success', "Profile image updated", 'Success');
            }

            setProfileImage(res.data.url);
            dispatch(fetchAndSetUserProfile());
        } catch (err) {
            handleErrors(err);
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.DASHBOARD} className="dashboard-link">
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.PROFILE} className="dashboard-link">
                            <span>Profile</span>
                        </Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="profile card card-body px-3 pt-3 pb-0">
                        <div className="profile-head">
                            {/*
                             <div className="photo-content">
                                <div className="cover-photo rounded"></div>
                            </div> 
                            */}
                            <div className="profile-info">
                                <div className="profile-photo">
                                    <label htmlFor="profile-upload" style={{ cursor: 'pointer' }}>
                                        <img
                                            src={profileImage}
                                            className="img-fluid rounded-circle"
                                            alt="Profile"
                                        />
                                    </label>
                                    <input
                                        type="file"
                                        id="profile-upload"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleImageChange}
                                    />
                                </div>
                                <div className="profile-details d-flex justify-content-between">
                                    <div className="profile-name px-3 pt-2">
                                        <h4 className="text-primary mb-0">{user?.name}</h4>
                                        <p>{user?.username} <br /> {user?.email}</p>
                                    </div>
                                    <div className="profile-name px-3 pt-2 text-end">
                                        {!user.iev ? (
                                            <button type="button" onClick={handleEmailVerify} className="btn btn-info btn-xs">Verify Email</button>
                                        ) : (
                                                <span className="badge bg-success">
                                                    <i className="fa fa-check-circle me-1"></i>
                                                    Verified
                                                </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12">

                    <div className="card h-auto">
                        <div className="card-body">
                            <div className="settings-form">
                                <h4 className="text-primary">Edit Profile</h4>
                                <form>
                                    <div className="row">
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Name</label>
                                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Username</label>
                                            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="form-control" />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Email</label>
                                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
                                        </div>
                                    </div>
                                    <button className="btn btn-primary" type="button" onClick={handleProfileSave}>
                                        <i className="fa fa-floppy-disk"></i>&nbsp;
                                        Save
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="card h-auto">
                        <div className="card-body">
                            <div className="settings-form">
                                <h4 className="text-primary">Change Password</h4>
                                <form>
                                    <div className="row">
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Current Password</label>
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                placeholder="Current Password" 
                                                value={currentPassword} 
                                                onChange={(e) => setCurrentPassword(e.target.value)} 
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">New Password</label>
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                placeholder="New Password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)} 
                                            />
                                        </div>
                                    </div>
                                    <button className="btn btn-primary" type="button" onClick={handlePasswordChange}>
                                        <i className="fa fa-floppy-disk"></i>&nbsp;
                                        Save
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Profile
